// main.tsx
import { useEffect } from "react";
import { ForeignExchangeRatesCard } from "./card";
import { ForeignExchangeRatesNew } from "./new";
import { Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { ForeignExchangeRatesTable } from "./table";

export default function ForeignExchangeRate() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("foreign_exchange_rate.document_title");
  }, [t]);

  return (
    <Routes>
      <Route index element={<ForeignExchangeRatesTable />} />
      <Route path="/new" element={<ForeignExchangeRatesNew />} />
      <Route path=":id" element={<ForeignExchangeRatesCard />} />
    </Routes>
  );
}
